import { ResolvableModeEnum } from '@e-socna/data-layer';

export const DEFAULT_MODE = ResolvableModeEnum.Static;
